import {alpha, styled} from "@mui/material"

interface LoadingCoverContainerProps {
    breadcrumbsEnabled: boolean
    isMerchandisedUrl: boolean
}

export const LoadingCoverContainer = styled("div")<LoadingCoverContainerProps>(
    ({theme, breadcrumbsEnabled, isMerchandisedUrl}) => ({
        position: "fixed",
        top: `calc(var(--next-header-lg-height, 6.5625rem)${
            breadcrumbsEnabled && isMerchandisedUrl ? " + var(--next-plp-breadcrumbs-height)" : ""
        })`,
        left: 0,
        width: "100%",
        height: `calc(100vh - var(--next-header-lg-height, 6.5625rem)${
            breadcrumbsEnabled && isMerchandisedUrl ? " + var(--next-plp-breadcrumbs-height)" : ""
        })`,
        backgroundColor: alpha(theme.palette.background.paper, 0.6),
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    }),
)
